export const translations = {
  en: {
    nav: {
      shop: "Shop", categories: "Categories", advisor: "Find My Projector", simulator: "Simulator",
      compare: "Compare", bundles: "Bundles", accessories: "Accessories", wholesale: "Wholesale",
      about: "About", contact: "Contact", faq: "FAQ",
    },
    common: {
      shopProjectors: "Shop Projectors", findProjector: "Find My Projector", compareModels: "Compare Models",
      talkExpert: "Talk to an Expert", addToCart: "Add to Cart", added: "Added to cart", quickView: "Quick View",
      seeProjection: "See how it projects", viewDetails: "View Details", from: "From", inStock: "In Stock",
      lowStock: "Low Stock", preorder: "Pre-order", outStock: "Out of Stock", save: "Save", learnMore: "Learn more",
      viewAll: "View all", getStarted: "Get started", explore: "Explore", loading: "Loading\u2026",
      results: "results", clearAll: "Clear all", apply: "Apply", filters: "Filters", sortBy: "Sort by",
      search: "Search", searchPlaceholder: "Search projectors\u2026", compareAdd: "Compare", remove: "Remove",
      subtotal: "Subtotal", checkout: "Checkout", emptyCart: "Your cart is empty", continueShopping: "Continue shopping",
      recommended: "Recommended", specs: "Specifications", noResults: "No products match your filters.",
      brightness: "Brightness", resolution: "Resolution", throw: "Throw", price: "Price", useCase: "Use case",
      availability: "Availability", brand: "Brand", type: "Type", portable: "Portable",
      home: "Home", error: "Error \u2014 please try again",
    },
    sort: { featured: "Featured", price_asc: "Price: Low to High", price_desc: "Price: High to Low", lumens: "Brightest", rating: "Top Rated" },
    shopPage: { titleMuted: "\u2014 all projectors" },
    useCases: { home_cinema: "Home cinema", gaming: "Gaming", business: "Business", education: "Education", portable: "Portable", outdoor: "Outdoor", budget: "Budget", small_room: "Small rooms" },
    throwTypes: { standard: "Standard", short_throw: "Short throw" },
    specL: {
      resolution: "Resolution", supported: "Supported input", brightness: "Brightness", throwType: "Throw type",
      throwRatio: "Throw ratio", contrast: "Contrast", smartOs: "Smart OS", speakers: "Speakers", noise: "Noise",
      keystone: "Keystone", weight: "Weight", lampLife: "Lamp life", connectivity: "Connectivity", price: "Price", badges: "Badges",
    },
    pdpFaq: {
      q4k: "Does it support 4K?", a4k: "It has native {res} resolution and accepts {sup}.",
      qNoise: "Is it noisy?", aNoise: "Runs at a quiet {db} dB.",
      qCeiling: "Ceiling mountable?", aCeiling: "Yes \u2014 pair it with our ceiling mount accessory.",
    },
    hero: {
      eyebrow: "Premium Projection Studio",
      title1: "Bring cinema", title2: "home.",
      subtitle: "From home cinema to the boardroom \u2014 discover the perfect projector for your space, guided by experts and smart tools.",
      scroll: "Scroll to power on",
      projected: "Now projecting",
      catHome: "Home Cinema", catGaming: "Gaming", catPortable: "Portable", catBusiness: "Business",
    },
    categoriesTiles: {
      title: "One store,", titleMuted: "every kind of screen.",
      subtitle: "Whatever the room, the light, or the budget \u2014 there is a projector tuned for it.",
    },
    findSection: {
      eyebrow: "AI Projector Advisor",
      title: "Not sure which one?", titleMuted: "Let our advisor decide.",
      body: "Answer a few quick questions about your room, light and budget. Our Claude-powered advisor instantly shortlists the best match, best value, premium and portable picks \u2014 with the reasons why.",
      cta: "Start the advisor",
    },
    simSection: {
      eyebrow: "Projection Simulator",
      title: "See it on your wall", titleMuted: "before you buy.",
      body: "Enter your room distance and watch the projected image grow and shrink in a stylised room \u2014 then get models that fit your exact space.",
      cta: "Open the simulator",
    },
    bestSellers: { title: "Best sellers", titleMuted: "loved by cinema fans.", subtitle: "Our most popular projectors this season." },
    compareSection: { title: "Compare side by side,", titleMuted: "decide with confidence.", body: "Line up to three projectors and compare brightness, resolution, throw, noise and more in one clean table.", cta: "Open compare" },
    bundlesSection: { title: "Complete setups,", titleMuted: "bundled and discounted.", subtitle: "Everything you need for the perfect picture \u2014 saving up to 10%." },
    trust: {
      title: "Bought with confidence.",
      expert: "Expert Support", expertBody: "Real projection specialists, 7 days a week.",
      delivery: "Fast EU Delivery", deliveryBody: "Ships across Europe in 3\u20135 business days.",
      secure: "Secure Checkout", secureBody: "SSL-encrypted, safe payment every time.",
      warranty: "2-Year Warranty", warrantyBody: "30-day returns and full warranty support.",
      wholesale: "Wholesale & Reseller", wholesaleBody: "Direct shipping and bulk pricing for partners.",
    },
    footer: {
      tagline: "Premium projection, expertly guided.",
      shop: "Shop", support: "Support", company: "Company", legal: "Legal",
      newsletter: "Get projection tips & offers", subscribe: "Subscribe", emailPlaceholder: "Your email",
      rights: "All rights reserved.", language: "Language",
      reseller: "Reseller Inquiry", shipping: "Shipping & Returns", warranty: "Warranty & Support",
      privacy: "Privacy Policy", terms: "Terms of Service",
    },
    advisor: {
      title: "AI Projector Advisor", subtitle: "Tell me about your space and I\u2019ll find your perfect projector.",
      chat: "Chat", picks: "My Picks", placeholder: "e.g. Living room, 3m from the wall, movies at night, budget \u20ac200\u2026",
      send: "Send", getRecs: "Get my recommendations", thinking: "Thinking\u2026", startPrompt: "Start by describing your room, use and budget.",
      bestMatch: "Best Match", bestValue: "Best Value", premium: "Premium", portable: "Portable",
      why: "Why it fits", suggestedAcc: "Suggested accessories", noPicks: "Your recommendations will appear here.",
      nextQ: "You could also tell me", floating: "Ask the Advisor",
      quickChips: ["Home cinema under \u20ac150", "Bright room, daytime use", "Portable for camping", "Gaming, low input lag"],
    },
    simulator: {
      title: "Projection Simulator", subtitle: "Find the perfect projector for your exact room.",
      distance: "Projector distance", roomWidth: "Room width", ambient: "Ambient light", useCase: "Main use",
      budget: "Budget", desiredImage: "Desired image size", throwType: "Throw type",
      dark: "Dark room", dim: "Some light", bright: "Bright room",
      imageSize: "Projected image", diagonal: "Diagonal", suggestedScreen: "Suggested screen",
      fits: "Fits your room", tooClose: "May be too close", tooFar: "May be too far", brightEnough: "Bright enough", mayBeDim: "May look dim",
      recommended: "Recommended for your room", any: "Any", calculate: "Update simulation",
      inches: "inches", projector: "Projector", wall: "Wall",
      screen: "screen", goodFit: "Good fit", tooBig: "Exceeds screen",
    },
    compare: {
      title: "Compare Projectors", subtitle: "Up to three models, side by side.",
      empty: "Add projectors to compare them here.", addProjectors: "Browse projectors", bestFor: "Quick verdicts",
      bestGaming: "Best for gaming", bestCinema: "Best for home cinema", brightest: "Brightest", bestValue: "Best value", mostPortable: "Most portable",
      addSlot: "Add projector", remove: "Remove",
    },
    bundles: { title: "Bundles & Setups", subtitle: "Complete, curated setups \u2014 save up to 10%.", includes: "Includes", bundlePrice: "Bundle price", youSave: "You save", addBundle: "Add bundle to cart" },
    accessories: { title: "Accessories", subtitle: "Screens, mounts, audio, cables and more to complete your setup." },
    product: {
      keySpecs: "Key specs", idealFor: "Ideal for", technical: "Technical details", description: "Description",
      completeSetup: "Complete your setup", relatedProjectors: "You may also like", relatedBundles: "Bundle & save",
      projectionPreview: "See it in a room", reviews: "Reviews", faqTitle: "Frequently asked", bulkInquiry: "Need several units? Request a bulk quote",
      addAccessories: "Add accessories", shipping: "Free EU shipping \u00b7 3\u20135 days", warranty: "2-year warranty \u00b7 30-day returns",
      inThisRoom: "In a 3m room this projects roughly", buyNow: "Add to Cart",
    },
    wholesale: {
      title: "Wholesale & Reseller", subtitle: "Partner with us for bulk pricing, dropshipping and direct EU shipping.",
      company: "Company name", name: "Your name", email: "Email", country: "Country", phone: "Phone",
      volume: "Expected monthly volume", interest: "Area of interest", message: "Message",
      submit: "Request a quote", success: "Thank you \u2014 our partnerships team will be in touch within 1 business day.",
      dropTitle: "Direct shipping & dropshipping", dropBody: "We ship directly to your customers across the EU under your brand, with no minimum stock.",
      b1: "Competitive wholesale pricing", b2: "Dropshipping & direct EU delivery", b3: "Dedicated partner support", b4: "Marketing assets & product data feed",
    },
    contact: { title: "Contact Us", subtitle: "Questions about a projector or your order? We\u2019re here.", name: "Your name", email: "Email", subject: "Subject", message: "Message", submit: "Send message", success: "Message sent \u2014 we\u2019ll reply shortly." },
    pages: {
      aboutTitle: "About BEAMLUX", aboutBody: "BEAMLUX is a premium projection studio and reseller. We believe the big screen belongs in every home, classroom and boardroom \u2014 so we curate the best projectors, guide every buyer with real expertise, and make setup effortless.",
      faqTitle: "Frequently Asked Questions",
      shippingTitle: "Shipping & Returns", warrantyTitle: "Warranty & Support",
      privacyTitle: "Privacy Policy", termsTitle: "Terms of Service",
    },
  },
  hr: {
    nav: {
      shop: "Trgovina", categories: "Kategorije", advisor: "Pronađi projektor", simulator: "Simulator",
      compare: "Usporedi", bundles: "Setovi", accessories: "Dodaci", wholesale: "Veleprodaja",
      about: "O nama", contact: "Kontakt", faq: "Česta pitanja",
    },
    common: {
      shopProjectors: "Kupi projektore", findProjector: "Pronađi projektor", compareModels: "Usporedi modele",
      talkExpert: "Pitaj stručnjaka", addToCart: "Dodaj u košaricu", added: "Dodano u košaricu", quickView: "Brzi pregled",
      seeProjection: "Kako projicira", viewDetails: "Detalji", from: "Od", inStock: "Na zalihi",
      lowStock: "Još malo na zalihi", preorder: "Prednarudžba", outStock: "Nema na zalihi", save: "Ušteda", learnMore: "Saznaj više",
      viewAll: "Prikaži sve", getStarted: "Započni", explore: "Istraži", loading: "Učitavanje\u2026",
      results: "rezultata", clearAll: "Očisti sve", apply: "Primijeni", filters: "Filtri", sortBy: "Sortiraj",
      search: "Pretraži", searchPlaceholder: "Pretraži projektore\u2026", compareAdd: "Usporedi", remove: "Ukloni",
      subtotal: "Međuzbroj", checkout: "Plaćanje", emptyCart: "Vaša košarica je prazna", continueShopping: "Nastavi s kupnjom",
      recommended: "Preporučeno", specs: "Specifikacije", noResults: "Nijedan proizvod ne odgovara filtrima.",
      brightness: "Svjetlina", resolution: "Rezolucija", throw: "Projekcijska udaljenost", price: "Cijena", useCase: "Namjena",
      availability: "Dostupnost", brand: "Marka", type: "Tip", portable: "Prijenosni",
      home: "Početna", error: "Greška \u2014 pokušajte ponovno",
    },
    sort: { featured: "Izdvojeno", price_asc: "Cijena: od niže", price_desc: "Cijena: od više", lumens: "Najsvjetliji", rating: "Najbolje ocijenjeni" },
    shopPage: { titleMuted: "\u2014 svi projektori" },
    useCases: { home_cinema: "Kućno kino", gaming: "Gaming", business: "Posao", education: "Obrazovanje", portable: "Prijenosni", outdoor: "Na otvorenom", budget: "Povoljno", small_room: "Male sobe" },
    throwTypes: { standard: "Standardni", short_throw: "Kratka udaljenost" },
    specL: {
      resolution: "Rezolucija", supported: "Podržani ulaz", brightness: "Svjetlina", throwType: "Tip projekcije",
      throwRatio: "Omjer projekcije", contrast: "Kontrast", smartOs: "Smart OS", speakers: "Zvučnici", noise: "Buka",
      keystone: "Korekcija slike", weight: "Težina", lampLife: "Vijek lampe", connectivity: "Povezivost", price: "Cijena", badges: "Oznake",
    },
    pdpFaq: {
      q4k: "Podržava li 4K?", a4k: "Ima nativnu {res} rezoluciju i prihvaća {sup}.",
      qNoise: "Je li glasan?", aNoise: "Radi na tihih {db} dB.",
      qCeiling: "Može li se montirati na strop?", aCeiling: "Da \u2014 uparite ga s našim stropnim nosačem.",
    },
    hero: {
      eyebrow: "Premium projekcijski studio",
      title1: "Donesite kino", title2: "kući.",
      subtitle: "Od kućnog kina do dvorane za sastanke \u2014 pronađite savršen projektor za svoj prostor, uz stručne savjete i pametne alate.",
      scroll: "Skrolajte za uključivanje",
      projected: "Upravo se projicira",
      catHome: "Kućno kino", catGaming: "Gaming", catPortable: "Prijenosni", catBusiness: "Poslovni",
    },
    categoriesTiles: {
      title: "Jedna trgovina,", titleMuted: "svaka vrsta platna.",
      subtitle: "Kakva god soba, svjetlo ili budžet \u2014 postoji projektor stvoren za to.",
    },
    findSection: {
      eyebrow: "AI savjetnik za projektore",
      title: "Niste sigurni koji?", titleMuted: "Neka savjetnik odluči.",
      body: "Odgovorite na nekoliko kratkih pitanja o sobi, svjetlu i budžetu. Naš savjetnik pokretan Claudeom odmah predlaže najbolji izbor, najbolju vrijednost, premium i prijenosne opcije \u2014 uz obrazloženje.",
      cta: "Pokreni savjetnika",
    },
    simSection: {
      eyebrow: "Simulator projekcije",
      title: "Pogledajte na svom zidu", titleMuted: "prije kupnje.",
      body: "Unesite udaljenost u sobi i gledajte kako projicirana slika raste i smanjuje se u stiliziranoj sobi \u2014 zatim dobijte modele koji odgovaraju vašem prostoru.",
      cta: "Otvori simulator",
    },
    bestSellers: { title: "Najprodavaniji", titleMuted: "omiljeni među ljubiteljima kina.", subtitle: "Naši najpopularniji projektori ove sezone." },
    compareSection: { title: "Usporedite jedan uz drugi,", titleMuted: "odlučite sa sigurnošću.", body: "Poredajte do tri projektora i usporedite svjetlinu, rezoluciju, projekcijsku udaljenost, buku i više u jednoj preglednoj tablici.", cta: "Otvori usporedbu" },
    bundlesSection: { title: "Kompletni setovi,", titleMuted: "spakirani i sniženi.", subtitle: "Sve što vam treba za savršenu sliku \u2014 uz uštedu do 10%." },
    trust: {
      title: "Kupujte s povjerenjem.",
      expert: "Stručna podrška", expertBody: "Pravi stručnjaci za projekciju, 7 dana u tjednu.",
      delivery: "Brza EU dostava", deliveryBody: "Isporuka diljem Europe za 3\u20135 radnih dana.",
      secure: "Sigurno plaćanje", secureBody: "SSL šifrirano, sigurno plaćanje svaki put.",
      warranty: "2 godine jamstva", warrantyBody: "Povrat u 30 dana i puno jamstvo.",
      wholesale: "Veleprodaja i preprodaja", wholesaleBody: "Izravna dostava i cijene za partnere.",
    },
    footer: {
      tagline: "Premium projekcija, uz stručno vodstvo.",
      shop: "Trgovina", support: "Podrška", company: "Tvrtka", legal: "Pravno",
      newsletter: "Savjeti i ponude za projekciju", subscribe: "Pretplati se", emailPlaceholder: "Vaš e-mail",
      rights: "Sva prava pridržana.", language: "Jezik",
      reseller: "Upit za preprodaju", shipping: "Dostava i povrat", warranty: "Jamstvo i podrška",
      privacy: "Politika privatnosti", terms: "Uvjeti korištenja",
    },
    advisor: {
      title: "AI savjetnik za projektore", subtitle: "Recite mi nešto o svom prostoru i pronaći ću vam savršen projektor.",
      chat: "Razgovor", picks: "Moji izbori", placeholder: "npr. Dnevni boravak, 3 m od zida, filmovi navečer, budžet \u20ac200\u2026",
      send: "Pošalji", getRecs: "Daj mi preporuke", thinking: "Razmišljam\u2026", startPrompt: "Počnite opisom sobe, namjene i budžeta.",
      bestMatch: "Najbolji izbor", bestValue: "Najbolja vrijednost", premium: "Premium", portable: "Prijenosni",
      why: "Zašto odgovara", suggestedAcc: "Predloženi dodaci", noPicks: "Vaše preporuke pojavit će se ovdje.",
      nextQ: "Možete mi također reći", floating: "Pitaj savjetnika",
      quickChips: ["Kućno kino do \u20ac150", "Svijetla soba, danju", "Prijenosni za kampiranje", "Gaming, nisko kašnjenje"],
    },
    simulator: {
      title: "Simulator projekcije", subtitle: "Pronađite savršen projektor za svoju sobu.",
      distance: "Udaljenost projektora", roomWidth: "Širina sobe", ambient: "Ambijentalno svjetlo", useCase: "Glavna namjena",
      budget: "Budžet", desiredImage: "Željena veličina slike", throwType: "Tip projekcije",
      dark: "Tamna soba", dim: "Malo svjetla", bright: "Svijetla soba",
      imageSize: "Projicirana slika", diagonal: "Dijagonala", suggestedScreen: "Preporučeno platno",
      fits: "Odgovara sobi", tooClose: "Možda preblizu", tooFar: "Možda predaleko", brightEnough: "Dovoljno svijetlo", mayBeDim: "Može biti tamno",
      recommended: "Preporučeno za vašu sobu", any: "Bilo koji", calculate: "Ažuriraj simulaciju",
      inches: "inča", projector: "Projektor", wall: "Zid",
      screen: "platno", goodFit: "Odlično pristaje", tooBig: "Prelazi platno",
    },
    compare: {
      title: "Usporedi projektore", subtitle: "Do tri modela, jedan uz drugi.",
      empty: "Dodajte projektore kako biste ih usporedili.", addProjectors: "Pregledaj projektore", bestFor: "Brzi zaključci",
      bestGaming: "Najbolji za gaming", bestCinema: "Najbolji za kućno kino", brightest: "Najsvjetliji", bestValue: "Najbolja vrijednost", mostPortable: "Najprijenosniji",
      addSlot: "Dodaj projektor", remove: "Ukloni",
    },
    bundles: { title: "Setovi i paketi", subtitle: "Kompletni, pažljivo odabrani setovi \u2014 ušteda do 10%.", includes: "Uključuje", bundlePrice: "Cijena seta", youSave: "Uštedite", addBundle: "Dodaj set u košaricu" },
    accessories: { title: "Dodaci", subtitle: "Platna, nosači, zvučnici, kabeli i više za vaš setup." },
    product: {
      keySpecs: "Ključne specifikacije", idealFor: "Idealno za", technical: "Tehnički detalji", description: "Opis",
      completeSetup: "Upotpunite svoj setup", relatedProjectors: "Moglo bi vam se svidjeti", relatedBundles: "Set i ušteda",
      projectionPreview: "Pogledajte u sobi", reviews: "Recenzije", faqTitle: "Česta pitanja", bulkInquiry: "Trebate više komada? Zatražite ponudu",
      addAccessories: "Dodaj dodatke", shipping: "Besplatna EU dostava \u00b7 3\u20135 dana", warranty: "2 godine jamstva \u00b7 povrat u 30 dana",
      inThisRoom: "U sobi od 3 m projicira otprilike", buyNow: "Dodaj u košaricu",
    },
    wholesale: {
      title: "Veleprodaja i preprodaja", subtitle: "Partnerstvo za veleprodajne cijene, dropshipping i izravnu EU dostavu.",
      company: "Naziv tvrtke", name: "Vaše ime", email: "E-mail", country: "Država", phone: "Telefon",
      volume: "Očekivana mjesečna količina", interest: "Područje interesa", message: "Poruka",
      submit: "Zatraži ponudu", success: "Hvala \u2014 naš partnerski tim javit će se u roku od 1 radnog dana.",
      dropTitle: "Izravna dostava i dropshipping", dropBody: "Šaljemo izravno vašim kupcima diljem EU pod vašim brendom, bez minimalne zalihe.",
      b1: "Konkurentne veleprodajne cijene", b2: "Dropshipping i izravna EU dostava", b3: "Posvećena podrška partnerima", b4: "Marketinški materijali i feed podataka",
    },
    contact: { title: "Kontaktirajte nas", subtitle: "Pitanja o projektoru ili narudžbi? Tu smo.", name: "Vaše ime", email: "E-mail", subject: "Predmet", message: "Poruka", submit: "Pošalji poruku", success: "Poruka poslana \u2014 uskoro odgovaramo." },
    pages: {
      aboutTitle: "O BEAMLUX-u", aboutBody: "BEAMLUX je premium projekcijski studio i preprodavač. Vjerujemo da veliko platno pripada svakom domu, učionici i dvorani \u2014 zato biramo najbolje projektore, vodimo svakog kupca uz pravo znanje i činimo postavljanje jednostavnim.",
      faqTitle: "Često postavljana pitanja",
      shippingTitle: "Dostava i povrat", warrantyTitle: "Jamstvo i podrška",
      privacyTitle: "Politika privatnosti", termsTitle: "Uvjeti korištenja",
    },
  },
};
